import { FC } from 'react';
import styles from './ButtonLoader.module.scss';

interface ILoaderProps {
  size: number;
  className?: any;
}

const ButtonLoader: FC<ILoaderProps> = ({ size, className }) => {
  return (
    <div className={className || styles.wrapper}>
      <div style={{ width: size, height: size }} className={styles.spinner} />
    </div>
  );
};

export default ButtonLoader;
